import * as React from 'react';
import {
  ThemeColorValue,
  ThemeNamedColor,
  ThemeNamedType,
} from '../../theme/theme-interface';
import { Badge, BadgeContainer } from './badge-style';
import { mapBadgeValues } from './map-badge-style';

export interface PositionProps {
  right?: string | number;
  top?: string | number;
  left?: string | number;
  bottom?: string | number;
}

export interface BadgeProps {
  color?: ThemeNamedColor | ThemeColorValue;
  value?: string | number;
  position?: PositionProps;
  type?: ThemeNamedType;
  show?: boolean;
}

const POS_INITIAL = 'initial';

export const BaSeBadge: React.FC<BadgeProps> = (props) => {
  const {
    color: textColor,
    style: { bgC, border },
  } = React.useMemo(
    () => mapBadgeValues(props.color ?? 'default')[props.type ?? 'primary'],
    [props.color, props.type],
  );

  const showBadge = React.useMemo(() => props.show ?? true, [props.show]);

  return (
    <BadgeContainer>
      {props.children}

      {showBadge && props.value !== undefined && (
        <Badge
          right={props.position?.right ?? POS_INITIAL}
          left={props.position?.left ?? POS_INITIAL}
          bottom={props.position?.bottom ?? POS_INITIAL}
          top={props.position?.top ?? POS_INITIAL}
          bgC={bgC}
          border={border}
          color={textColor}
        >
          {typeof props.value === 'string'
            ? props.value
            : props.value > 9
            ? '9+'
            : props.value < -9
            ? '9-'
            : props.value}
        </Badge>
      )}
    </BadgeContainer>
  );
};

BaSeBadge.displayName = 'BaSeBadge';
